import { ReactNode } from "react"
import { useSelector } from "react-redux"
import store from "src/redux/Store"
import { selectUserAccess } from "src/redux/slicers/homeSlice"

const hasAccess = (
  id: string | Array<string> | any,
  userAccess?: Map<any, any>
) => {
  const fallbackAccess = selectUserAccess(store.getState() as any)
  const accessMap =
    userAccess instanceof Map
      ? userAccess
      : fallbackAccess instanceof Map
        ? fallbackAccess
        : new Map()
  if (Array.isArray(id)) {
    return Boolean(id.some((i) => accessMap.has(i)))
  }

  return accessMap.has(id)
}

export const accessControlFunc = (props: {
  id: string | Array<string> | any
  userAccess?: Map<any, any> | undefined
}) => {
  return hasAccess(props.id, props.userAccess)
}

interface AccessControlProps {
  /** Node to appear inside of button element */
  children?: ReactNode
  id: string | Array<string>
}

export const AccessControl = ({ children, id }: AccessControlProps) => {
  const accessMap = useSelector(selectUserAccess)
  return hasAccess(id, accessMap) ? <>{children}</> : <></>
}